// extracted by mini-css-extract-plugin
export default {"tablePagination":"UserList_tablePagination__+LH4t"};